import { adminFetchSubscriptionsByUserId } from '@/actions/adminActions'
import { useFetchResponse } from '@/utils/sharedHooks'
import { StripeSubscriptionDetailsPanel } from './StripeSubscriptionDetailsPanel'
import { SubscriptionEntitlementsPanel } from './SubscriptionEntitlementsPanel'

const isProd = process.env.VITE_IS_PROD === 'true'

const STRIPE_DASHBOARD_BASE_URL = 'https://dashboard.stripe.com'
export const getStripeCustomerURL = (customerId: string) =>
  `${STRIPE_DASHBOARD_BASE_URL}/${
    !isProd ? 'test/' : ''
  }customers/${customerId}`

interface Props {
  userId: number
  isUnservicedFreeTrial?: boolean
}

export const AccountDetailsTabPanel = ({
  userId,
  isUnservicedFreeTrial,
}: Props) => {
  const data = useFetchResponse(adminFetchSubscriptionsByUserId, userId)

  return (
    <div className="w-full flex flex-col gap-4">
      <StripeSubscriptionDetailsPanel
        userId={userId}
        isUnservicedFreeTrial={isUnservicedFreeTrial}
        subscriptions={data?.subscriptions}
        liteDowngradeEligibility={data?.liteDowngradeEligibility ?? null}
      />
      <SubscriptionEntitlementsPanel
        userId={userId}
        subscriptions={data?.subscriptions}
      />
    </div>
  )
}
